'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

var AccessibleFormat = function AccessibleFormat(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 26 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 26 : _ref$width;
  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-accessible-format ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 26 26' },
    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M11.328125,7.734375 L8.671875,14.765625 C10.21875,14.78125 11.765625,14.828125 13.3125,14.828125 C13.609375,14.828125 13.90625,14.8125 14.203125,14.796875 C13.390625,12.421875 12.4375,10 11.328125,7.734375 Z M0,25 L0.03125,23.765625 C1.5,23.3125 3.09375,23.625 3.75,21.9375 L7.453125,12.3125 L11.828125,1 L13.828125,1 C13.890625,1.109375 13.953125,1.21875 14,1.328125 L17.203125,8.828125 C18.375,11.59375 19.453125,14.390625 20.640625,17.140625 C21.34375,18.765625 21.890625,20.4375 22.671875,22.03125 C22.78125,22.28125 23,22.75 23.21875,22.921875 C23.734375,23.328125 25.171875,23.421875 25.90625,23.703125 C25.953125,24 26,24.296875 26,24.59375 C26,24.734375 25.984375,24.859375 25.984375,25 C24,25 22.015625,24.75 20.03125,24.75 C17.984375,24.75 15.9375,24.921875 13.890625,24.984375 C13.890625,24.578125 13.90625,24.171875 13.953125,23.765625 L16,23.328125 C16.421875,23.234375 17.25,23.125 17.25,22.546875 C17.25,21.984375 15.234375,17.34375 14.984375,16.703125 L7.953125,16.671875 C7.546875,17.578125 5.96875,21.671875 5.96875,22.265625 C5.96875,23.46875 8.265625,23.515625 9.15625,23.640625 C9.171875,23.9375 9.171875,24.234375 9.171875,24.546875 C9.171875,24.6875 9.15625,24.828125 9.140625,24.96875 C7.328125,24.96875 5.5,24.65625 3.6875,24.65625 C3.46875,24.65625 3.15625,24.75 2.9375,24.78125 C1.953125,24.953125 0.984375,25 0,25 Z' })
  );
};

AccessibleFormat.propTypes = _bcPropTypes.iconShape;

exports.default = AccessibleFormat;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/AccessibleFormat/AccessibleFormat.js
// module id = 115
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15